import type { CardType } from "../features/tarot/domain/data/models/card-type";
import the_fool from  '../assets/images/cards/the-fool.png'
import the_magician from  '../assets/images/cards/the-magician.png'
import the_high_priestess from  '../assets/images/cards/the-high-priestess.png'
import the_empress from  '../assets/images/cards/the-empress.png'
import the_emperor from  '../assets/images/cards/the-emperor.png'
import the_hierophant from  '../assets/images/cards/the-hierophant.png'
import the_lovers from  '../assets/images/cards/the-lovers.png'
import the_chariot from  '../assets/images/cards/the-chariot.png'
import strength from  '../assets/images/cards/strength.png'
import the_hermit from  '../assets/images/cards/the-hermit.png'
import wheel_of_fortune from  '../assets/images/cards/wheel-of-fortune.png'
import justice from  '../assets/images/cards/justice.png'
import the_hanged_man from  '../assets/images/cards/the-hanged-man.png'
import death from  '../assets/images/cards/death.png'
import temperance from  '../assets/images/cards/temperance.png'
import the_devil from  '../assets/images/cards/the-devil.png'
import the_tower from  '../assets/images/cards/the-tower.png'
import the_star from  '../assets/images/cards/the-star.png'
import the_moon from  '../assets/images/cards/the-moon.png'
import the_sun from  '../assets/images/cards/the-sun.png'
import judgement from  '../assets/images/cards/judgement.png'
import the_world from  '../assets/images/cards/the-world.png'


export class AppConstants {

  static cardsMap: CardType[] = [
    {image: the_fool, title: "the-fool", description: ""},
    {image: the_magician, title: "the-magician", description: ""},
    {image: the_high_priestess, title: "the-high-priestess", description: ""},
    {image: the_empress, title: "the-empress", description: ""},
    {image: the_emperor, title: "the-emperor", description: ""},
    {image: the_hierophant, title: "the-hierophant", description: ""},
    {image: the_lovers, title: "the-lovers", description: ""},
    {image: the_chariot, title: "the-chariot", description: ""},
    {image: strength, title: "strength", description: ""},
    {image: the_hermit, title: "the-hermit", description: ""},
    {image: wheel_of_fortune, title: "the-wheel-of-fortune", description: ""},
    {image: justice, title: "justice", description: ""},
    {image: the_hanged_man, title: "the-hanged-man", description: ""},
    {image: death, title: "death", description: ""},
    {image: temperance, title: "temperance", description: ""},
    {image: the_devil, title: "the-devil", description: ""},
    {image: the_tower, title: "the-tower", description: ""},
    {image: the_star, title: "the-star", description: ""},
    {image: the_moon, title: "the-moon", description: ""},
    {image: the_sun, title: "the-sun", description: ""},
    {image: judgement, title: "judgment", description: ""},
    {image: the_world, title: "the-world", description: ""},
  ]

  static cardOb: {[key: string]: CardType} = {
    "the-fool": this.cardsMap[0],
    "the-magician": this.cardsMap[1],
    "the-high-priestess": this.cardsMap[2],
    "the-empress": this.cardsMap[3],
    "the-emperor": this.cardsMap[4],
    "the-hierophant": this.cardsMap[5],
    "the-lovers": this.cardsMap[6],
    "the-chariot": this.cardsMap[7],
    "strength": this.cardsMap[8],
    "the-hermit": this.cardsMap[9],
    "the-wheel-of-fortune": this.cardsMap[10],
    "justice": this.cardsMap[11],
    "the-hanged-man": this.cardsMap[12],
    "death": this.cardsMap[13],
    "temperance": this.cardsMap[14],
    "the-devil": this.cardsMap[15],
    "the-tower": this.cardsMap[16],
    "the-star": this.cardsMap[17],
    "the-moon": this.cardsMap[18],
    "the-sun": this.cardsMap[19],
    "judgment": this.cardsMap[20],
    "the-world": this.cardsMap[21],
  }

}